<hr-customer-edit-agent-list
  *ngIf="mode == Mode.List"
  (onEdit)="onEditCustomerAgent($event)"
  (onAdd)="onAddCustomerAgent($event)"
  (onStatusUpdate)="onUpdateCustomerAgent($event)"
  [customer]="customerInput"
></hr-customer-edit-agent-list>
<hr-customer-agent-editor
  *ngIf="mode == Mode.Edit || mode == Mode.Add"
  (onUpdate)="onUpdateCustomerAgent($event)"
  [currentEditingAgent]="currentEditingAgent"
  [mode]="mode"
></hr-customer-agent-editor>
